import { cohortAPI } from '@/providers/apis/cohort/cohort';
import { copy } from '@/utils/cohort';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CohortList from './cohort-list/cohort-list';
import { groupsApi } from '@/providers/apis/groups/groups';
import { isAPICatchError, sortByProperty } from '@/utils/utils';
import { sessionService } from '@/providers/services/auth/session';
import { EventBus } from '@/main';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';

@Component({
    name: 'cohort-selection',
    components: {
        'cohort-list': CohortList,
    },
})

export default class CohortSelection extends Vue {
    // ---------------------------------------------------------------------
    // Properties

    private cohortLevel: any = [];

    private cohortLevelModified: any = [];

    private removeFromHierarchy: any = [];

    private isLoading: any = false;

    private aclList: any = {};

    @Prop({ default: {} })
    private userData: any;

    private rowItemSelected = {};

    private isSaving: boolean = false;

    private defaultSelection: any = {};

    // -------------------------------------------------------------------
    // Actions

    // -------------------------------------------------------------------
    // Hooks
    private created() {
        this.fetchUserACL();
    }


    // -------------------------------------------------------------------
    // Methods

    private fetchHierarchy() {
        this.isLoading = true;
        groupsApi.fetchUserHierarchies().then((hierarchy: any) => {
            for (const iterator of this.removeFromHierarchy) {
                hierarchy[0].levels = hierarchy[0].levels.filter((item: any) => {
                    return item.type !== iterator;
                });
            }
            sortByProperty(hierarchy[0].levels, 'sequence', 'ASC');
            this.cohortLevel = hierarchy[0].levels;

            for (const iterator of this.cohortLevel) {
                iterator.aclSelected = this.aclList && this.aclList.aclByType[iterator.type] || [];
                iterator.currentSelection = [];
            }
            this.fetchCohortListAll();
        });
    }

    private async fetchCohortListAll(isRefresh: boolean = false) {
        this.isLoading = true;
        const levels: any = copy(this.cohortLevel);
        for await (const [index, iterator] of levels.entries()) {
            iterator.child = {};
            if (iterator.type === 'class') {
                const itemBeforeClass = levels[index - 1];
                const keysBefore = Object.keys(itemBeforeClass.child).map(Number);
                for (const iteratorBefore of keysBefore) {
                    const cohoList = itemBeforeClass.child[iteratorBefore].cohortList;
                    for (const iteratorCoho of cohoList) {
                        iterator.child[iteratorCoho.id] = { selectedCohort: [], cohortList: [] };
                    }
                }
            } else {
                const paramsData: any = { type: iterator.type };
                if (isRefresh) {
                    paramsData.refresh = true;
                }
                iterator.child = await groupsApi.fetchGroupedHierarchyMapping(paramsData);
                const keys = Object.keys(iterator.child).map(Number);
                for (const [keyIndex, keyIterator] of keys.entries()) {
                    if (iterator.aclSelected && iterator.aclSelected.length > 0) {
                        iterator.child[keyIterator].cohortList.filter((selectedItem: any) =>
                            iterator.aclSelected.findIndex((item: any) => item.groups.includes(selectedItem.id) &&
                                item.parentReferenceId === selectedItem.parentId) >= 0)
                            .forEach((selectedNewItem: any) => {
                                selectedNewItem.preSelect = true;
                                selectedNewItem.checked = true;
                                iterator.child[keyIterator].selectedCohort.push(selectedNewItem);
                                iterator.currentSelection.push(selectedNewItem);
                            });
                    } else {
                        if (index === 0) {
                            if (keyIndex === 0) {
                                iterator.child[keyIterator].cohortList[0].checked = true;
                                iterator.child[keyIterator].selectedCohort.
                                    push(iterator.child[keyIterator].cohortList[0]);
                                iterator.currentSelection.push(iterator.child[keyIterator].cohortList[0]);
                                this.defaultSelection[iterator.sequence] = iterator.child[keyIterator].cohortList[0].id;
                            }
                        } else {
                            if (this.defaultSelection[iterator.sequence - 1] === keyIterator) {
                                iterator.child[keyIterator].cohortList[0].checked = true;
                                iterator.child[keyIterator].selectedCohort.
                                    push(iterator.child[keyIterator].cohortList[0]);
                                iterator.currentSelection.push(iterator.child[keyIterator].cohortList[0]);
                                this.defaultSelection[iterator.sequence] = iterator.child[keyIterator].cohortList[0].id;
                            }
                        }
                    }
                }

            }
            if (index === levels.length - 1) {
                this.isLoading = false;
                this.cohortLevelModified = levels;
                this.cohortLevel = levels;
            }
        }
    }

    private fetchUserACL() {
        const session: any = sessionService.getSession();
        const params = {
            userId: this.userData.id,
            tenantId: session.tenant!.tenant_id,
        };
        cohortAPI.fetchUserACL(params).then((data: any) => {
            if (!isAPICatchError(data)) {
                this.aclList = data;
            } else {
                this.aclList = {
                    aclByType: {},
                    aclList: [],
                };
            }
            EventBus.$emit('onCheckAcl', this.aclList.aclList);
            this.fetchHierarchy();
        });
    }

    private getCohortIndex(cohort: any) {
        return this.cohortLevel.findIndex((item: any) => {
            return item.sequence === cohort.sequence && item.type === cohort.type;
        });
    }

    private async selectOneListItem(selectedCohort: any, cohort: any) {
        const that = this;
        const selectedIndex = that.getCohortIndex(cohort);
        if (selectedIndex !== -1) {
            setTimeout(() => {
                for (let index = selectedIndex + 1; index < that.cohortLevel.length; index++) {
                    this.$set(that.rowItemSelected, that.cohortLevel[index].id, null);
                }
                if (selectedCohort && selectedCohort.id) {
                    setTimeout(() => {
                        const indexItem = that.cohortLevel[selectedIndex + 1];
                        if (indexItem && indexItem.id) {
                            this.$set(that.rowItemSelected, indexItem.id, selectedCohort.id);
                        }
                    });
                }
            }, 50);
        }
    }

    private checkParentWithChild(selectedCohortItem: any, cohort: any) {
        const that = this;
        const selectedIndex = that.getCohortIndex(cohort);
        if ((selectedIndex - 1) >= 0) {
            const beforeIndex = selectedIndex - 1;
            // for (let beforeIndex = selectedIndex - 1; beforeIndex > 0; beforeIndex--) {
            const keysBefore = Object.keys(that.cohortLevel[beforeIndex].child).map(Number);
            for (const iteratorKeys of keysBefore) {
                const itemList = that.cohortLevel[beforeIndex].child[iteratorKeys].cohortList;
                const selectedFilterIndex = itemList.findIndex((cohoItem: any) => {
                    return cohoItem.id === selectedCohortItem;
                });
                if (selectedFilterIndex !== -1) {
                    that.cohortLevel[beforeIndex].child[iteratorKeys].
                        cohortList[selectedFilterIndex].checked = true;
                    selectedCohortItem = iteratorKeys;
                    const selecedListIndex = that.cohortLevel[beforeIndex].child[iteratorKeys].selectedCohort.
                        findIndex((selected: any) => {
                            return selected.id === that.cohortLevel[beforeIndex].child[iteratorKeys].
                                cohortList[selectedFilterIndex].id;
                        });
                    if (selecedListIndex === -1) {
                        that.cohortLevel[beforeIndex].child[iteratorKeys].selectedCohort.
                            push(that.cohortLevel[beforeIndex].child[iteratorKeys].cohortList[selectedFilterIndex]);
                        that.cohortLevel[beforeIndex].currentSelection.
                            push(that.cohortLevel[beforeIndex].child[iteratorKeys].cohortList[selectedFilterIndex]);
                    }
                }
            }
            // }
        }
    }

    private async saveACL() {
        const listAcl: any = [];
        this.isSaving = true;
        let isCalculationDone = false;
        let type = 'class';
        const cohoLevel = copy(this.cohortLevel);
        sortByProperty(cohoLevel, 'sequence', 'DESC');
        for await (const [i, iterator] of cohoLevel.entries()) {
            isCalculationDone = false;
            type = iterator.type;
            const keys = Object.keys(iterator.child).map(Number);
            if (iterator.type === 'class') {
                const iteratorSchool = cohoLevel[i + 1];
                let selectedClassParent: any = [];
                const schoolParentKeys = Object.keys(iteratorSchool.child).map(Number);
                for await (const [keyParentIndex, schoolParent] of schoolParentKeys.entries()) {
                    isCalculationDone = false;
                    if (iteratorSchool.child[schoolParent] &&
                        iteratorSchool.child[schoolParent].selectedCohort &&
                        iteratorSchool.child[schoolParent].selectedCohort.length > 0) {
                        selectedClassParent = [...selectedClassParent,
                        ...iteratorSchool.child[schoolParent].selectedCohort];
                    }
                }

                for await (const iteratorSchoolCoho of selectedClassParent) {
                    const classCoho = iterator.child[iteratorSchoolCoho.id];
                    if ((classCoho.selectedCohort.length === classCoho.cohortList.length)
                        || classCoho.selectedCohort.length === 0) {
                        const newObj: any = {
                            userId: this.userData.id,
                            tenantId: this.$access.getTenantId(),
                            parentReferenceId: iteratorSchoolCoho.id,
                            type: 'class',
                            groups: ['*'],
                        };
                        listAcl.push(newObj);
                    } else {
                        const groups = [];
                        for await (const classIterator of classCoho.selectedCohort) {
                            groups.push(classIterator.id);
                        }
                        const newObj: any = {
                            userId: this.userData.id,
                            tenantId: this.$access.getTenantId(),
                            parentReferenceId: iteratorSchoolCoho.id,
                            type: 'class',
                            groups,
                        };
                        listAcl.push(newObj);
                    }
                }
            } else {
                for await (const [keyIndex, iteratorKey] of keys.entries()) {
                    isCalculationDone = false;
                    const selectedCohort = iterator.child[iteratorKey] ?
                        iterator.child[iteratorKey].selectedCohort : [];
                    for await (const [cohortIndex, cohort] of selectedCohort.entries()) {
                        isCalculationDone = false;
                        const parentIndex = listAcl.findIndex((item: any) => {
                            return item.parentReferenceId === cohort.parentId && item.type === cohort.type;
                        });
                        if (parentIndex === -1) {
                            const newObj: any = {
                                userId: this.userData.id,
                                tenantId: this.$access.getTenantId(),
                                parentReferenceId: cohort.parentId,
                                type: cohort.type,
                                groups: [cohort.id],
                            };
                            listAcl.push(newObj);
                        } else {
                            if (!listAcl[parentIndex].groups.includes(cohort.id)) {
                                listAcl[parentIndex].groups.push(cohort.id);
                            }
                        }
                        if (i >= cohoLevel.length - 1 && keyIndex === keys.length - 1 &&
                            cohortIndex === selectedCohort.length - 1 &&
                            type === 'country') {
                            isCalculationDone = true;
                        }
                    }
                }
            }
        }

        if (isCalculationDone === true && type === 'country') {
            const params = {
                list_acl: listAcl,
            };
            setTimeout(() => {
                cohortAPI.updateUserACL(params).then((data: any) => {
                    this.isSaving = false;
                    if (!isAPICatchError(data)) {
                        this.$emit('onSwitchComponent', 'user-list');
                    }
                });
            }, 5000);
        }
    }

    private async checkCohoBackwards() {
        const listAcl: any = [];
        this.isSaving = true;
        let isCalculationDone = false;
        const cohoLevel = copy(this.cohortLevel);
        sortByProperty(cohoLevel, 'sequence', 'DESC');
        for await (const [i, iterator] of cohoLevel.entries()) {
            isCalculationDone = false;
            const keys = Object.keys(iterator.child).map(Number);
            for await (const [keyIndex, iteratorKey] of keys.entries()) {
                isCalculationDone = false;
                const selectedCohort = iterator.child[iteratorKey] ? iterator.child[iteratorKey].selectedCohort : [];
                // for reverse check to parent is selected start --------------------------
                if (selectedCohort && selectedCohort.length > 0) {
                    if (i - 1 > 0) {
                        const iteratorParent = this.cohortLevel[i - 1];
                        const keysParent = Object.keys(iteratorParent.child).map(Number);
                        for await (const [keyParentIndex, iteratorParentKey] of keysParent.entries()) {
                            isCalculationDone = false;
                            const parentCohortSelected = iteratorParent.child[iteratorParentKey] ?
                                iteratorParent.child[iteratorParentKey].selectedCohort : [];
                            const parentCohortList = iteratorParent.child[iteratorParentKey] ?
                                iteratorParent.child[iteratorParentKey].cohortList : [];
                            const cohortListIndex = parentCohortList.findIndex((item: any) => {
                                return item.id === iteratorKey;
                            });
                            if (cohortListIndex !== -1) {
                                const cohortSelectedIndex = parentCohortSelected.findIndex((item: any) => {
                                    return item.id === iteratorKey;
                                });
                                if (cohortSelectedIndex === -1) {
                                    iteratorParent.child[iteratorParentKey].selectedCohort.
                                        push(parentCohortList[cohortListIndex]);
                                }
                            }
                        }
                    }
                }
                // for reverse check to parent is selected end --------------------------
            }
        }
        return cohoLevel;
    }

    private selectAllChild(event: any, cohort: any, selectedItem?: any) {
        const selectedIndex = this.getCohortIndex(cohort);
        const choosenFrom = selectedItem ? copy(selectedItem) : {};
        let itrKey = [choosenFrom.id];
        if (event) {
            let keys: any = [];
            for (let index = selectedIndex + 1; index < this.cohortLevel.length; index++) {
                keys = [];
                const iterator = this.cohortLevel[index];
                for (const iteratorKey of itrKey) {
                    const cohortObj = iterator.child[iteratorKey];
                    if (cohortObj && cohortObj.cohortList && cohortObj.cohortList.length > 0) {
                        for (const iteratorCoho of cohortObj.cohortList) {
                            keys.push(iteratorCoho.id);
                            iteratorCoho.checked = true;
                            const selectIndex = cohortObj.selectedCohort.findIndex((item: any) => {
                                return item.id === iteratorCoho.id && item.parentId === iteratorCoho.parentId;
                            });
                            if (selectIndex === -1) {
                                cohortObj.selectedCohort.push(iteratorCoho);
                                iterator.currentSelection.push(iteratorCoho);
                            }
                        }
                    }
                }
                itrKey = keys;
            }
            // this.checkInBackward(event, cohort, selectedItem);
        }
    }

    private unCheckAllChild(event: any, cohort: any, selectedItem: any) {
        const choosenFrom = copy(selectedItem);
        let itrKey = [choosenFrom.id];
        if (!event) {
            const selectedIndex = this.getCohortIndex(cohort);
            let keys: any = [];
            for (let index = selectedIndex + 1; index < this.cohortLevel.length; index++) {
                keys = [];
                const iterator = this.cohortLevel[index];
                for (const iteratorKey of itrKey) {
                    const cohortObj = iterator.child[iteratorKey];
                    if (cohortObj && cohortObj.cohortList && cohortObj.cohortList.length > 0) {
                        for (const iteratorCoho of cohortObj.cohortList) {
                            keys.push(iteratorCoho.id);
                            iteratorCoho.checked = false;
                            const currentIndex = iterator.currentSelection.findIndex((item: any) => {
                                return item.id === iteratorCoho.id && item.parentId === iteratorCoho.parentId;
                            });
                            if (currentIndex !== -1) {
                                iterator.currentSelection.splice(currentIndex, 1);
                            }
                        }
                        this.$set(this.cohortLevel[index].child[iteratorKey], 'selectedCohort', []);

                    }
                }
                itrKey = keys;
            }
        }
    }

    private checkInBackward(event: any, cohort: any, selectedItem?: any) {
        const levels: any = this.cohortLevel;
        const choosenFrom = selectedItem ? copy(selectedItem) : {};
        let parentKey = choosenFrom.parentId;
        if (event) {
            const selectedIndex = this.getCohortIndex(cohort);
            let keys: any = [];
            for (let index = selectedIndex - 1; index > 0; index--) {
                keys = [];
                const iterator = levels[index];
                keys = Object.keys(iterator.child).map(Number);
                for (const iteratorKey of keys) {
                    const parentObjIndex = iterator.child[iteratorKey].cohortList.findIndex((item: any) => {
                        return item.id === parentKey;
                    });
                    const parentSelectedIndex = iterator.child[iteratorKey].selectedCohort.findIndex((item: any) => {
                        return item.id === parentKey;
                    });
                    if (parentObjIndex !== -1) {
                        parentKey = iterator.child[iteratorKey].cohortList[parentObjIndex].parentId;
                        iterator.child[iteratorKey].cohortList[parentObjIndex].checked = true;
                    }
                    if (parentSelectedIndex === -1) {
                        iterator.child[iteratorKey].selectedCohort.
                            push(iterator.child[iteratorKey].cohortList[parentObjIndex]);
                    }

                }
            }
        }
    }

    private onSaveAcl() {
        const that = this;
        EventBus.$on('onSaveAcl', () => {
            that.saveACL();
        });
    }

    private onRefreshGroup() {
        const isRefresh = true;
        this.fetchCohortListAll(isRefresh);
    }
}
